import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import FormField from '../Form/FormField';
import FormCheck from '../Form/FormCheck';
import i18n from '../../i18n';
import FormColor from '../Form/FormColor';

const CostCenterEdit = (props) => {

    const [values, setValues] = useState(props.values);
    const [edit, setEdit] = useState(props.edit || false);

    return (
        <TableRow>
            <TableCell>
                {edit ? (
                    <FormField
                        type={'text'}
                        name={'number'}
                        label={i18n.get('config.cost_center.number')}
                        value={values.number}
                        onChange={(e) => {
                            setValues({...values, number: e.target.value});
                        }}
                    />
                ) : values.number}
            </TableCell>
            <TableCell>
                {edit ? (
                    <FormField
                        type={'text'}
                        name={'name'}
                        label={i18n.get('config.cost_center.self')}
                        value={values.name}
                        onChange={(e) => {
                            setValues({...values, name: e.target.value});
                        }}
                    />
                ) : values.name}
            </TableCell>
            {/*<TableCell>
                {edit ? (
                    <React.Fragment>
                        {values.color}
                        <FormColor
                            color={values.color || '#999999'}
                            onChange={(color) => {
                                setValues({...values, color: color});
                            }}
                        />
                    </React.Fragment>
                ) : (
                    <Icon style={{color: values.color || ''}}>color_lens</Icon>
                )}
            </TableCell>
            <TableCell>
                {
                    edit ? (
                        <FormCheck name={'closed'} value={values.closed}
                            // label_exclaim={i18n.get('project.status_form.exclaim_closed')}
                                   onChange={(e, chk) => {
                                       setValues({...values, closed: chk});
                                   }}/>
                    ) : values.closed && (
                        <Icon>assignment_turned_in</Icon>
                    )
                }
            </TableCell>
            */}
            <TableCell>
                {edit ? (
                    <React.Fragment>
                        <IconButton
                            onClick={() => {
                                setEdit(false);
                                if (props.onChange) {
                                    props.onChange(values);
                                }
                            }}
                        >
                            <Icon>save</Icon>
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                setEdit(false);
                                props.setCanAdd(true);
                                setValues(props.values);
                            }}
                        >
                            <Icon>cancel</Icon>
                        </IconButton>
                    </React.Fragment>
                ) : (
                    <IconButton size={'small'}
                        onClick={() => {
                            setEdit(true);
                            props.setCanAdd(false);
                        }}
                    >
                        <Icon>edit</Icon>
                    </IconButton>
                )}
            </TableCell>
        </TableRow>
    );
};

const styles = {};

export default withStyles(styles)(CostCenterEdit);
